import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { currency, fullPrice, heroImage, included } from '../data/copy';
export function OfferSection() {
  return <section id="oferta" className="defer-paint w-full scroll-mt-6 bg-paper py-10 sm:py-14" aria-labelledby="offer-heading" data-id="element-156" data-mp="8m3uvkaht1vt">
      <div className="mx-auto max-w-5xl px-6" data-id="element-157" data-mp="idrmbl71uixa">
        <div className="mx-auto mb-8 max-w-xl" data-id="element-158" data-mp="icymz5af6vp6">
          <CountdownTimer data-id="element-159" data-mp="meabf7hk5avs" />
        </div>

        {/* Un solo marco engloba la presentación del pack y la tarjeta de
            precio: todo lo que se compra hoy vive dentro del mismo borde. */}
        <div id="acceso" className="scroll-mt-6 rounded-3xl border border-green/30 bg-shell p-6 shadow-lift sm:p-8" data-id="element-160" data-mp="wdj31toyadez">
          <div className="mx-auto max-w-2xl text-center" data-id="element-161" data-mp="2t745iusndgsl">
            <p className="eyebrow text-green-deep" data-id="element-162" data-mp="2y3ksvms0vr4m">Tu acceso completo hoy</p>
            <h2 id="offer-heading" className="mt-3 font-display text-[1.75rem] font-bold leading-[1.1] text-ink sm:text-[2.2rem]" data-id="element-163" data-mp="12n8k3ov69ojk">
              MEGAPACK Educación Física 360
            </h2>
            <p className="mt-2 font-sans text-[0.95rem] leading-relaxed text-muted" data-id="element-164" data-mp="syqn7iq0k1l7">
              6 volúmenes · 120 sesiones completas · 5 bonos · acceso de por vida.
            </p>
          </div>

          <div className="mt-7 grid items-center gap-6 lg:grid-cols-[1fr_1.05fr] lg:gap-8" data-id="element-165" data-mp="1llbgioq1unre">
            <img src={heroImage} alt="El MEGAPACK Educación Física 360 completo: 6 volúmenes, 5 bonos y la plataforma de recursos." className="mx-auto w-full max-w-xs lg:max-w-sm" width={1240} height={1240} loading="lazy" decoding="async" data-id="element-166" data-mp="1gn1fvylk2uye" />

            <div className="rounded-2xl border border-line bg-paper p-5 text-center sm:p-6" data-id="element-167" data-mp="146h7k2f7cjq">
              <p className="font-sans text-sm text-muted" data-id="element-168" data-mp="3sex3vg79kfbb">
                Valor normal:{' '}
                <span className="line-through" data-id="element-169" data-mp="3trwryw36d55r">
                  {fullPrice} {currency}
                </span>
              </p>
              <p className="mt-1 flex items-start justify-center gap-1 font-display font-bold leading-none text-ink" data-id="element-170" data-mp="3ktl431tp0lh0">
                <span className="mt-2 text-2xl text-green" data-id="element-171" data-mp="3ou52s9twzx59">$</span>
                <span className="text-[3.5rem] leading-none sm:text-[4.25rem]" data-id="element-172" data-mp="3b3i2wecf417l">
                  19
                </span>
              </p>
              <p className="mt-1.5 font-sans text-xs uppercase tracking-[0.16em] text-muted" data-id="element-173" data-mp="3fv9u8r3eeays">
                {currency} · pago único · en tu moneda local
              </p>

              <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-1.5 border-t border-line pt-5 text-left sm:gap-x-6" data-id="element-174" data-mp="3645dpmy2qi1u">
                {included.map(item => <li key={item} className="flex items-start gap-2 font-sans text-[0.8rem] leading-snug text-ink" data-id="element-175" data-mp="2s6qmcco9g078">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green" strokeWidth={2.6} aria-hidden="true" data-id="element-176" data-mp="2diqctt9yzj1a" />
                    {item}
                  </li>)}
              </ul>

              <CtaButton size="large" className="mt-6 w-full" data-id="element-177" data-mp="2ig8m5krwg09t">
                Quiero mi MEGAPACK
              </CtaButton>

              <p className="mt-3 text-center font-sans text-[11px] text-muted" data-id="element-178" data-mp="2weyfcpbllfsw">
                Pago seguro · acceso inmediato · garantía de 7 días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}